import React from 'react';

const MetricCard = ({ icon, iconColor = 'text-primary', iconBg = 'bg-primary-transparent', label, value }) => {
  return (
    <div className="card custom-card">
      <div className="card-body text-center">
        <div className={`icon-service ${iconBg} rounded-circle ${iconColor} mb-2`}>
          <i className={icon}></i>
        </div>
        <p className="mb-1 text-muted">{label}</p>
        <h3 className="mb-0">{value}</h3>
      </div>
    </div>
  );
};

export default MetricCard;
